export default "__VITE_ASSET__c10eceae__"